import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="issue-status"
export default class extends Controller {
  connect() {
    // Listen for Turbo events to manage loading state
    this.boundHandleSubmitEnd = this.handleSubmitEnd.bind(this)
    document.addEventListener('turbo:submit-end', this.boundHandleSubmitEnd)
  }

  disconnect() {
    document.removeEventListener('turbo:submit-end', this.boundHandleSubmitEnd)
  }

  update(event) {
    // Add loading state - but don't disable the button as it prevents form submission
    const button = event.target.closest('button')
    if (button) {
      button.classList.add('loading')
      // Store reference to reset on error
      this.loadingButton = button
    }
  }

  handleSubmitEnd(event) {
    // Reset loading state if there was an error (success replaces the element via Turbo Stream)
    if (!event.detail.success && this.loadingButton) {
      this.loadingButton.classList.remove('loading')
      this.loadingButton = null
    }
  }
}
